module.exports = "/packs/005-debbc0aa1811af1f03ec6c7ee4d57c97.jpg";